<template>
  <div :class="['form-input-wrapper']">
    <div class="input-shell">
      <CInput
        v-bind="options"
        :placeholder="placeholder"
        v-on="_listener_"
        v-model="data.model"
        :type="resolvedType"
        :readonly="options.readonly"
        :class="{
          'input-valid-error': data.validator && !data.validator.isValid,
          'no-label': !(options && options.label)
        }"
      >
        <label
          slot="label"
          :class="(options.horizontal && options.horizontal.label) ? 'col-form-label ' + options.horizontal.label : ''"
          v-html="options.label"
        ></label>
        <label slot="append" v-if="options.append">{{ options.append }}</label>
      </CInput>

      <!-- Overlay icon "hide/show password" (neo theo ô input, không bị nhảy khi error line xuất hiện) -->
      <button
        v-if="showPasswordToggle"
        type="button"
        class="password-toggle-btn"
        :aria-label="showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'"
        @click="togglePassword"
      >
        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
      </button>
    </div>
    <div class="form-row" v-show="!(data.validator ? data.validator.isValid : true)">
      <label slot="label"
        :class="(options.horizontal && options.horizontal.label) ? 'col-form-label ' + options.horizontal.label : ''"> </label>
      <div class="valid-error" :class="(options.horizontal && options.horizontal.input) ? options.horizontal.input : ''">
        {{ data.validator ? data.validator.errorMessage : "" }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["options", "data", "listener"],
  data() {
    var that = this;
    return {
      lastValueUpdateTrigger: that.data.model,
      showPassword: false,
    };
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  methods: {
    setLastValueUpdateTrigger: function () {
      this.lastValueUpdateTrigger = this.data.model;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
  computed: {
    showPasswordToggle() {
      return (
        this.options &&
        String(this.options.type || '').toLowerCase() === 'password' &&
        this.options.showPasswordToggle !== false
      );
    },
    resolvedType() {
      if (!this.showPasswordToggle) return this.options ? this.options.type : 'text';
      return this.showPassword ? 'text' : 'password';
    },
    hasValid: function () {
      return this.data.validator && this.data.validator.valid;
    },
    hasUpdateTrigger: function () {
      // console.log(this.lastValueUpdateTrigger, this.data.model)
      return (
        typeof this.data.updateTrigger === "function" &&
        this.lastValueUpdateTrigger !== this.data.model
      );
    },
    hasUpdateCallback: function () {
      return typeof this.data.updateCallback === "function";
    },
    validOnInput: function () {
      return (
        this.options &&
        this.options.validOnInput &&
        this.data.validator &&
        this.data.validator.valid
      );
    },
    placeholder: function () {
      return this.options
        ? this.options.placeholder || this.options.label
        : this.data
          ? this.data.name
          : "";
    },
    _listener_: function () {
      let _listenter = {};
      let that = this;
      if (that.hasUpdateTrigger || that.hasUpdateCallback || that.hasValid) {
        _listenter.keyup = function (event) {
          let valid = true;
          if (that.validOnInput) {
            valid = that.data.validator.valid();
          }
          if (valid && that.hasUpdateTrigger && event.key === "Enter") {
            that.data.updateTrigger().loadData();
            that.setLastValueUpdateTrigger();
          }
          if (valid && that.hasUpdateCallback && event.key === "Enter") {
            that.data.updateCallback();
          }
        };

        _listenter.blur = function (event) {
          if (that.hasValid) {
            setTimeout(function () {
              var valid = that.data.validator.valid();
              if (valid && that.hasUpdateTrigger) {
                that.data.updateTrigger().loadData();
                that.setLastValueUpdateTrigger();
              }
            }, 250);
          } else if (that.hasUpdateTrigger) {
            that.data.updateTrigger().loadData();
            that.setLastValueUpdateTrigger();
          }
        };
      }
      for (let attr in this.listener) {
        _listenter[attr] = this.listener[attr];
      }

      return _listenter;
    }
  },
  watch: {}
};
</script>
<style scoped>
.form-input-wrapper {
  overflow: visible;
}

.input-shell {
  position: relative;
}

.password-toggle-btn {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  position: absolute;
  right: 8px;
  top: auto;
  bottom: 6px;
  transform: none;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  cursor: pointer;
  color: rgba(15, 23, 42, 0.75);
  background: rgba(15, 23, 42, 0.05);
  z-index: 2;
}

.password-toggle-btn:hover {
  color: rgba(15, 23, 42, 0.98);
  background: rgba(15, 23, 42, 0.10);
}

/* Make room for the toggle icon (CInput renders input inside) */
.input-shell >>> input.form-control,
.input-shell >>> .form-control {
  padding-right: 54px !important;
}

.form-input-wrapper >>> .password-toggle-btn i {
  font-size: 1.05rem!important;
}
</style>
